import PageTabs from '../../ui/PageTabs';
import { t } from '../../utils/i18n';
import { useApiEnvironment } from '../../context/ApiEnvironmentContext';
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import CelebRoomPersonaGate from '../../layout/CelebRoomPersonaGate';
import CelebRoomFeed from './CelebRoomFeed';
import MyCelebRoom from './MyCelebRoom';
import CelebRoomView from './CelebRoomView';
import CelebRoomFans from './CelebRoomFans';
import CelebFollow from './CelebFollow';

export default function CelebRoomSection() {
  const { pathname } = useLocation();
  const { apiEnvironment } = useApiEnvironment();
  const views = [["feed", "celebRoomFeed"], ["mine", "celebRoomMine"], ["follow", "celebRoomFollow"]];
  const active = pathname.startsWith('/celeb-room/c/') ? 'conversations' : pathname.startsWith('/celeb-room/r/') ? 'feed' : pathname.split('/')[2];
  return (
    <div>
    {active !== 'users' && <div className="px-4 sm:px-6 lg:px-8"><PageTabs label={t('adminUi.qa')} active={active} items={views.filter(([id]) => id !== 'follow' || apiEnvironment === 'test').map(([id,key]) => ({id,to:`/celeb-room/${id}`,label:t(`header.nav.${key}`)}))} /></div>}
    <Routes>
      <Route index element={<Navigate to="feed" replace />} />
      <Route
        path="feed"
        element={
          <CelebRoomPersonaGate>
            <CelebRoomFeed />
          </CelebRoomPersonaGate>
        }
      />
      <Route
        path="mine"
        element={
          <CelebRoomPersonaGate>
            <MyCelebRoom />
          </CelebRoomPersonaGate>
        }
      />
      <Route
        path="follow"
        element={
          <CelebRoomPersonaGate>
            <CelebFollow />
          </CelebRoomPersonaGate>
        }
      />
      <Route
        path="r/:roomId"
        element={
          <CelebRoomPersonaGate>
            <CelebRoomView />
          </CelebRoomPersonaGate>
        }
      />
      <Route
        path="r/:roomId/fans"
        element={
          <CelebRoomPersonaGate>
            <CelebRoomFans />
          </CelebRoomPersonaGate>
        }
      />
      <Route path="*" element={<Navigate to="feed" replace />} />
    </Routes>
    </div>
  );
}
